import { Badge } from '../ui/badge';

/**
 * BattleHistoryItem — single row in user's battle history list.
 */
export default function BattleHistoryItem({ battle }) {
  const resultClass = battle.result === 'win'
    ? 'bg-green-500/20 text-green-300'
    : battle.result === 'loss'
      ? 'bg-red-500/20 text-red-300'
      : 'bg-yellow-500/20 text-yellow-300';
  const resultLabel = battle.result === 'win'
    ? 'Victoire'
    : battle.result === 'loss'
      ? 'Défaite'
      : 'Nul';

  return (
    <div className="flex items-center gap-4 p-4 border-b border-white/5 last:border-0 hover:bg-white/5 transition-colors" data-testid={`battle-row-${battle.id}`}>
      <div className="w-12 h-12 rounded-2xl bg-white/5 flex items-center justify-center text-2xl">
        {battle.opponent === 'ai' ? '🤖' : '🎤'}
      </div>
      <div className="flex-1">
        <div className="font-bold text-white text-sm capitalize">{battle.mode} vs {battle.opponent_name}</div>
        <div className="text-xs text-zinc-400">{new Date(battle.created_at).toLocaleString('fr-FR')}</div>
      </div>
      <div className="text-right">
        <Badge className={`${resultClass} border-0`}>{resultLabel}</Badge>
        <div className="text-xs text-zinc-400 mt-1">{battle.my_score} - {battle.opponent_score}</div>
        <div className="text-[10px] text-pink-400 mt-0.5">+{battle.xp_earned} XP • +{battle.coins_earned}c</div>
      </div>
    </div>
  );
}
